import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PenaltyFareBasisMachineLearning } from 'src/app/core/models/cancellation.model';
import { Currency } from 'src/app/core/models/models';

interface GroupSelect {
  name: string;
  options: string[];
}
@Component({
  selector: 'app-input-select-addon',
  templateUrl: './input-select-addon.component.html',
  styleUrls: ['./input-select-addon.component.scss']
})
export class InputSelectAddonComponent implements OnInit {
  @Output() onChangeDynamicClases = new EventEmitter<string>();
  @Output() onChangeDisabledStatus = new EventEmitter<boolean>();

  groupValues;
  static;
  classUnderlinedByPassenger: string;

  inputAdultValue = 'inputadult';
  inputChildValue = 'inputchild';
  inputInfantValue = 'inputinfant';
  isInputFocused = false;

  @Input() placeholder = '';
  @Input() type = 'number';
  @Input() label = '';
  @Input() id = '';
  @Input() valueInput: number | string;
  @Input() valueSelect: string;
  @Input() valuesGroupAddon: GroupSelect[];
  @Input() valuesAddon: string[];
  @Input() currencies: Currency[];
  @Input() disabled: boolean;
  @Input() isGroup: boolean;
  @Input() isStatic: boolean;
  @Input() staticText: string;
  @Input() error: boolean;
  @Input() errorMessage: string;
  @Input() maxLength: string;
  @Input() minLength: string;
  @Input() underlined = false;
  @Input() passengerType = '';
  @Input() allowMl = false;
  @Input() farebasisMl: PenaltyFareBasisMachineLearning;
  @Output() changeSelect = new EventEmitter<string>();
  @Output() changeValue = new EventEmitter<number | string>();

  @Input() set localCoin(value: string) {
    if (this.valuesAddon && !this.valuesAddon.includes(value)) {
      this.valuesAddon.push(value);
    }
  }

  ngOnInit(): void {
    if (this.allowMl) {
      this.valueInput = this.farebasisMl?.penaltyValues.find(
        (pv) => pv.passengerType === this.passengerType
      ).value;
      this.onChangeDisabledStatus.emit(false);
    }
  }

  get displayValue(): number | string {
    if (this.type !== 'number' || this.isInputFocused || this.valueInput === '' || this.valueInput == null) {
      return this.valueInput;
    }
    const amount = Number(this.valueInput);
    return Number.isFinite(amount) ? amount.toFixed(2) : this.valueInput;
  }

  updateValue(value: number | string): void {
    this.valueInput = this.type === 'number'
      ? (value === '' || value == null ? null : Number(value))
      : value;
    this.changeValue.emit(this.valueInput);
  }

  whereIsFocusedElement(id: string): void {
    this.isInputFocused = true;
    this.classUnderlinedByPassenger = id;
    this.onChangeDynamicClases.emit(this.classUnderlinedByPassenger);
  }

  restoreUnderlinedClass(): void {
    this.isInputFocused = false;
    this.classUnderlinedByPassenger = undefined;
    this.onChangeDynamicClases.emit(undefined);
  }
}
